import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import {
  PostAllCBSNsList,
  PostAllGCMinerVersions,
  PostAllSerialNumbers,
} from "../../api/api";
import { useState } from "react";

type GetSoftwareVersionsList = {
  open: boolean;
  authToken: string;
  version: string;
};

type SoftwareVersions = {
  SoftwareVersions: string;
  // isDefaultTag: boolean;
  // occurrence: number;
};

type VersionsList = {
  status: string;
  msg: SoftwareVersions[];
};

export const useListSoftwareVersions = ({
  open,
  authToken,
  version,
}: GetSoftwareVersionsList): UseInfiniteQueryResult<
  VersionsList,
  Error
> => {
  const [totalCount, setTotalCount] = useState(0);
  let limit = 25;

  return useInfiniteQuery({
    queryKey: ["listSoftwareVersions", open, version],
    initialPageParam: { skip: 0, limit },
    staleTime: 1000 * 60 * 5,
    queryFn: ({
      pageParam,
    }: {
      pageParam: { skip: number; limit: number };
    }) =>
      PostAllGCMinerVersions({
        authToken,
        body: {
          device: pageParam,
          filter: {
            version,
          },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken && !!open,
    getNextPageParam: (
      lastPage: VersionsList,
      allPages: VersionsList[]
    ) => {
      const totalFetched = allPages.flatMap(
        (page) => page.msg
      ).length;

      // Stop fetching if the total fetched rows reach or exceed the total count
      if (totalFetched >= totalCount) {
        return undefined;
      }

      // Return the skip value for the next page
      return { skip: allPages.length * limit, limit };
    },
  });
};
